module.exports = __webpack_public_path__ + "static/media/robot-chat.db45f2c3.svg";